export enum LoginSaveAction {
	Created,
	Saved,
	Cancelled
}
